(function() {
  // estimer date de livraison
  if(document.getElementById('fromDate')) {

    var dateDebut = 6;
    var dateFin = 12;

    var fromDate = Date.today().addDays(dateDebut);
    if (fromDate.is().saturday() || fromDate.is().sunday()) { 
      fromDate = fromDate.next().monday();
    }
    var toDate = Date.today().addDays(dateFin);
    if (toDate.is().saturday() || toDate.is().sunday()) { 
      toDate = toDate.next().monday(); 
    }
    document.getElementById('fromDate').innerHTML = fromDate.toString('dd/MM');
    document.getElementById('toDate').innerHTML = toDate.toString('dd/MM');
  }
})();